import * as firebase from 'firebase/app';
import 'firebase/firestore';
const { firebaseConfig, spreadsheetConfig } = require(`../config/${process.env.NODE_ENV}`);

firebase.initializeApp(firebaseConfig);

interface FetchedUser {
  user_name: string;
  id1: number;
  in_office: string;
  user_yomi: string;
}

export interface Member {
  id: number;
  name: string;
  inOffice: boolean;
  yomi: string;
}

export interface KeyHolder {
  member: Member;
  since: Date;
}

export class MemberRepository {
  db: firebase.firestore.Firestore;

  constructor() {
    this.db = firebase.firestore();
  }

  fetchAll(): Promise<Member[]> {
    const MEMBER_API = spreadsheetConfig.url;
    // Google Spread Sheet (GAS API)から取得する
    return fetch(MEMBER_API)
      .then(reponse => reponse.json())
      .then(records => records.map((r: FetchedUser) => {
        return {
          id: r.id1,
          name: r.user_name,
          yomi: r.user_yomi,
          inOffice: r.in_office === "yes",
        };
      }));
  }

  fetchHolder(): Promise<KeyHolder[]> {
    // Cloud firestoreから取得する
    return this.db.collection("keyholders").doc("latest").get()
      .then((doc) => {
        if (!doc.exists) {
          return [];
        }
        return doc.data().holders.map((h) => {
          // NOTE: firebaseから取得する日付が
          //       firebase.Timestamp型なので、Dateに変換しておく
          return { member: h.member, since: h.since.toDate() }
        })
      });
  }

  storeHolder(holders: KeyHolder[]): void {
    const now = new Date();
    const doc = {
      created_at: now,
      holders: holders,
    };
    // Cloud firestoreに保存する
    const db = this.db;
    const batch = db.batch();
    const latestRef = db.collection("keyholders").doc("latest");
    batch.set(latestRef, doc);
    const historyRef = db.collection("keyholdersHistory").doc(dateToString(now));
    batch.set(historyRef, doc);
    batch.commit()
      .then(() => { console.log("keyholders successfully write.") })
      .catch((err) => { console.error("error writing keyholders: ", err) });
  }
}

function pad(number: number): string {
  if (number < 10) {
    return '0' + number;
  }
  return '' + number;
}

function dateToString(dt: Date): string {
  return dt.getUTCFullYear() +
    pad(dt.getUTCMonth() + 1) +
    pad(dt.getUTCDate()) +
    pad(dt.getUTCHours()) +
    pad(dt.getUTCMinutes()) +
    pad(dt.getUTCSeconds()) +
    (dt.getUTCMilliseconds() / 1000).toFixed(3).slice(2, 5);
}

export enum SortMethod {
  ID_ASC = "id_asc",
  YOMI_ASC = "yomi_asc",
}

export class SortMethodStore {
  private storage: Storage;
  private static readonly STORE_KEY: string = "member.SortMethod";

  constructor() {
    this.storage = window.localStorage;
  }

  get method(): SortMethod {
    return this.storage.getItem(SortMethodStore.STORE_KEY) as SortMethod;
  }

  set method(netMethod: SortMethod) {
    this.storage.setItem(SortMethodStore.STORE_KEY, netMethod);
  }
}

